export const BACKGROUND_COLOR = '#0C1119'
export const SECONDARY_TEXT = '#CFD7E3'